module.exports = __webpack_public_path__ + "img/logo_aeterna_zentaris.d248456e.png";